import { useContext } from 'react';
import CompareContainer from '../CompareContainer';
import CategoryHeader from '../CategoryHeader';
import Button from '../../../shared/Button';
import Box from '../../../shared/layouts/Box';
import CompareApplicantSection from './CompareApplicantSection';
import CompareContactSection from './CompareContactSection';
import CompareHealthSection from './CompareHealthSection';
import CompareWorkIncomeSection from './CompareWorkIncomeSection';
import { CompareContext } from '../ComparePage';
import {useTranslation} from "react-i18next";
import useIconLibrary from "../../../../hooks/useIconLibrary";

const CompareApplicantPage = () => {
  const {
    showOnlyDiff,
    hasDiff,
    ownApplicantData,
    otherApplicantData,
    ownAddressData,
    otherAddressData,
    healthFields,
    workIncomeFields,
    contactInfoFields,
    personFields,
    hasPageCopiedFields,
    handleCopyAllFields,
    setOwnApplicantData,
  } = useContext(CompareContext);

  const { t } = useTranslation();
  const { ProfileIcon } = useIconLibrary();

  const fields = [
    ...healthFields,
    ...workIncomeFields,
    ...contactInfoFields,
    ...personFields,
  ];

  const PAGE = 'applicant';

  return (
    <CompareContainer
      section="profile"
      title={t("Gegevens")}
      icon={<ProfileIcon height="2rem" width="2rem" />}
    >
      {showOnlyDiff &&
      !hasDiff(fields, ownApplicantData, otherApplicantData) &&
      !hasPageCopiedFields(PAGE) &&
      !hasDiff(fields, ownAddressData, otherAddressData) ? (
        <Box fontScale="m" width="50%">{t('Geen afwijkende gegevens gevonden')}</Box>
      ) : (
        <>
          <CompareApplicantSection />
          <CompareContactSection />
          <CompareWorkIncomeSection />
          <CompareHealthSection />
          <CategoryHeader>
            <div />
            <Button
              onClick={() => {
                handleCopyAllFields(
                  otherApplicantData,
                  ownApplicantData,
                  'applicant',
                  setOwnApplicantData
                );
              }}
            >
              {t('Alle gegevens overnemen')}
            </Button>
          </CategoryHeader>
        </>
      )}
    </CompareContainer>
  );
};

export default CompareApplicantPage;
